"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const PageContent = (props) => {
    let className = "pageContent";
    if (!lodash_1.default.isEmpty(props.className)) {
        className = className + " " + props.className;
    }
    return react_1.default.createElement("div", { className: className },
        react_1.default.createElement(antd_1.Divider, { className: "pageContentTopDivider" }),
        props.children);
};
const Card = (props) => {
    return react_1.default.createElement("div", { className: "pageContentCard" }, props.children);
};
PageContent.Card = Card;
const CardSpacer = (props) => {
    return react_1.default.createElement("div", { className: "pageContentCardSpacer" }, props.children);
};
PageContent.CardSpacer = CardSpacer;
const CardSection = (props) => {
    return react_1.default.createElement("div", { className: "pageContentCardSection" }, props.children);
};
PageContent.CardSection = CardSection;
exports.default = PageContent;
